"use client";
import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "@/components/Button";
import styled from "styled-components";
import { useQueryClient } from "@tanstack/react-query";
import { modalHelper } from "@/components/services/QueryDataHelper";

const StyledIframe = styled.iframe`
  min-height: 800px;
  width: 100%;
  height: 100%;
`
const RatesDiv = styled.div`
  text-align:center;
  min-height: 800px;
  width: 100%;
  height: 100%;
  background-image: url("/assets/images/Rates-Video-Cover.jpg");
  background-repeat: no-repeat;
  background-size: contain;
  position:relative;
  button {
    position:absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%);
  }
`

function RatesPage() {
  const queryClient = useQueryClient();
  const { setModal } = modalHelper(queryClient);    
  const [ ratesVideoUrl, setRatesVideoUrl ] = useState("");

  useEffect(() => {
    if(localStorage["ratesVideoUrl"]) 
    {
      setRatesVideoUrl(localStorage["ratesVideoUrl"]); 
    }
    else
    {
      setModal("ratesvideo");
      // Hook up the event handler
      window.addEventListener("storage", storageEventHandler);
    }    

    // Respond to the `storage` event
    function storageEventHandler(event: any) {
      if(localStorage["ratesVideoUrl"]) 
      {
        setRatesVideoUrl(localStorage["ratesVideoUrl"]); 
      } 
    }
  
    return () => {
        // Remove the handler when the component unmounts
        window.removeEventListener("storage", storageEventHandler);
    };
  }, [])  

  return (
    <section className="StyledSection">
      <Container>
        <Row>
          <Col>
            <Card bg="trans-white">
              <Card.Body>
                <Card.Title><h1 className="blue-color">Low Mortgage Rates - Secrets You Can"t Afford to Miss</h1></Card.Title>
                <Card.Text as="div">
                  {ratesVideoUrl === "" ?
                    <RatesDiv>
                      <Button className="mb-4" size="lg" variant="orange" onClick={() => setModal("ratesvideo")} title={`Request free access to how people can get 2-3% Mortgage Rates`} aria-label={`Request free access to how people can get 2-3% Mortgage Rates`}>
                        Request Access <i role="presentation" className="bi bi-caret-right-fill"></i>
                      </Button> 
                    </RatesDiv>
                    :
                    <StyledIframe id="book-frame" width="100%" height="100%" src={ratesVideoUrl} allowFullScreen allow="autoplay" scrolling="no"></StyledIframe>  
                  }                        
                </Card.Text>                                                              
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>       
    </section>
  );
}

  
  export default RatesPage;